module.exports = __webpack_public_path__ + "static/media/code.51974e40.svg";